import { isPermissionAllowed } from './permissions';

/** آیا کاربر می‌تواند روی رکورد سرنخ (پیگیری، یادداشت، معامله در تب‌ها) عملیات انجام دهد */
export const canManageLeadRecord = (permissions) => {
  if (!permissions) return false;
  return isPermissionAllowed(permissions.edit);
};

export const canDeleteLeadRecord = (permissions) => {
  if (!permissions) return false;
  return isPermissionAllowed(permissions.delete);
};